// Bounded height for the embedded (mobile) document card so it scrolls internally, and for the
// matching loading skeleton block. Shared so the card and its skeleton can't drift apart.
export const MOBILE_DOCUMENT_HEIGHT = '65vh';
